document.addEventListener('DOMContentLoaded', function() {
    const swipersExpert = document.querySelectorAll('.expert-slider');
    swipersExpert.forEach(function(swiperElement) {
        const desktop_column_gap = parseInt(swiperElement.dataset.desktopgap, 10);
        const mobile_column_gap = parseInt(swiperElement.dataset.mobilegap, 10);
        new Swiper(swiperElement, {
            spaceBetween: mobile_column_gap,
            loop:true,
            slidesPerView: 'auto',
            breakpoints: {                
                749: {
                    spaceBetween: desktop_column_gap,
                },                
            },
        });
    });
});